import { InputNumber } from 'antd';
import React from 'react';

interface TimeInputProps {
  value?: number; // 초 단위
  onChange?: (value: number | undefined) => void;
  style?: React.CSSProperties;
  placeholder?: string;
}

/**
 * 분 단위로 시간을 입력받고 초 단위로 변환하여 반환하는 컴포넌트
 */
const TimeInput: React.FC<TimeInputProps> = ({
  value,
  onChange,
  style,
  placeholder = '0',
}) => {
  const minutesValue = value != null && value > 0 ? Math.round(value / 60) : undefined;

  const handleChange = (newValue: number | null) => {
    if (onChange) {
      onChange(newValue != null ? newValue * 60 : undefined);
    }
  };

  return (
    <InputNumber
      value={minutesValue}
      onChange={handleChange}
      placeholder={placeholder}
      style={style}
      min={0}
      precision={0}
      addonAfter="min"
    />
  );
};

export default TimeInput;
